export default "__VITE_ASSET__a6711894__"